import React from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import { Link } from 'react-router-dom';
import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';

import SeeProjectsIcon from '../../images/home/back-to-portfolio.png';

import './Landing.css';

const LandingSection = ({
  title, shortPhrase, shortDesc, video, image,
}) => {
  const auxWidth = window.screen.width;
  let tam = 85;
  if (auxWidth < 768) {
    tam = 100;
  }
  return (
    <div id="ProjectLanding">
      <div id="ProjectLandingTitle">
        <div id="BacktoPortfolio">
          <Link
            to="/portfolio"
          >
            <img src={SeeProjectsIcon} alt="up pointing arrow" />
            <p>BACK TO CATALOG</p>
          </Link>
        </div>
        <h1>{title}</h1>
        <h2>{shortPhrase}</h2>
        <p>{shortDesc}</p>
      </div>
      {video && (
        <div id="ProjectVideo">
          <YouTube
            className="youtube"
            videoId={video}
            opts={{ width: `${tam}%`, height: `${tam}%` }}
            onPlay={() => trackEvent(eventTypes.projectVideoPlay)}
            onPause={(arg) => {
              const { target } = arg;
              const elapsedTime = target.getCurrentTime();

              trackEvent(eventTypes.projectVideoPause, { value: elapsedTime });
            }}
          />
        </div>
      )}
      {image && !video && (
        <div id="ProjectImage">
          <img src={`../${image}-2.jpg`} alt="" />
        </div>
      )}
    </div>
  );
};

LandingSection.propTypes = {
  title: PropTypes.string.isRequired,
  shortPhrase: PropTypes.string.isRequired,
  shortDesc: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default LandingSection;
